export default __webpack_public_path__ + "static/media/main_instructions_dark.3a5dbd3f.svg";